import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "./redux/actions";

import MaterialTable from "material-table";
import AskAlert from "../common/AskAlert";
import {
  SERVER_PATH,
  AXIOS_CONFIG,
  ROLE_ADMIN,
} from "../common/redux/constantes";
import Fileupload from "../fileupload/Fileupload";

import moment from "moment";

class ListCatalog extends Component {
  static propTypes = {
    catalog: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    catalogs: [],
    openDeleteAlert: false,
    deleteCatalogID: -1,
    openUploadFileModal: false,
  };

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
  }

  deleteCatalog = () => {
    if (this.state.deleteCatalogID !== -1) {
      this.props.actions.deleteCatalog(
        this.tableRef,
        this.state.deleteCatalogID
      );
      this.setState({ openDeleteAlert: false });
    }
  };

  cancelDelete = () => {
    this.setState({ openDeleteAlert: false });
  };

  askDeleteCatalog = (catalogID) => {
    this.setState({ openDeleteAlert: true, deleteCatalogID: catalogID });
  };

  refreshTable = () => {
    this.tableRef.current && this.tableRef.current.onQueryChange();
  };
  uploadCsv = () => {
    this.setState({
      openUploadFileModal: true,
    });
  };
  closeCsvModal = () => {
    this.setState({
      openUploadFileModal: false,
    });
  };
  updateAfterCsv = () => {
    this.tableRef.current && this.tableRef.current.onQueryChange();
  };
  render() {

      let actionButtons =[
        rowData => ({
          icon: 'delete',
          tooltip: 'Delete',
          onClick: (event, rowData) => this.askDeleteCatalog(rowData.deliverable_catalog),
          disabled: rowData.shared===1 
        }),
        rowData => ({
          icon: 'edit',
          tooltip: 'Edit',
          onClick: (event, rowData) => this.props.editCatalog(rowData),
          disabled: rowData.shared===1 
        }),
        {
        icon: 'cloud_upload',
        tooltip: 'Import',
        isFreeAction: true,
        onClick: () => this.uploadCsv()
        },
        {
          icon: 'visibility',
          tooltip: 'View information',
          onClick: (event, rowData) => this.props.showCatalog(rowData) 
        },
        {
        icon: 'refresh',
        tooltip: 'Refresh Data',
        isFreeAction: true,
        onClick: () => this.uploadCsv(),
      },
      {
        icon: "refresh",
        tooltip: "Refresh Data",
        isFreeAction: true,
        onClick: () =>
          this.tableRef.current && this.tableRef.current.onQueryChange(),
      },
    ];
    //Verificamos permisos
    if (Number(localStorage.getItem("role")) !== ROLE_ADMIN) {
      actionButtons.splice(0, 3);
    }
    return (
      <div>
        <MaterialTable
          tableRef={this.tableRef}
          onRowClick={(evt, selectedRow) => this.setState({ selectedRow })}
          options={{
            actionsColumnIndex: 7,
            paging: false,
            search: false,
            maxBodyHeight: "600px",
            headerStyle: {
              backgroundColor: "#fffff",
              color: "black",
              fontSize: "1.05em",
            },
            rowStyle: (rowData) => {
              return {
                backgroundColor:
                  this.state.selectedRow &&
                  this.state.selectedRow.tableData.id === rowData.tableData.id
                    ? "#EEE"
                    : rowData.tableData.id % 2
                    ? "#fff"
                    : "#f9f9fa",
              };
            },
          }}
          title="Deliverable Catalog"
          columns={[
            {
              title: "Name",
              field: "name",
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
              },
            },
            {
              title: "Date Created",
              field: "date_created",
              cellStyle: {
                borderRight: "1px solid #d4d4d4",
              },
            },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = SERVER_PATH + "/deliverable_catalogs/getAll";
              fetch(url, AXIOS_CONFIG())
                .then((response) => response.json())
                .then((result) => {
                  result.deliverable_catalogs = result.deliverable_catalogs.map(
                    (o) => {
                      if (o.date_created) {
                        o.date_created = moment(o.date_created).format(
                          "YYYY-MM-DD"
                        );
                      }
                      return o;
                    }
                  );
                  resolve({
                    data: result.deliverable_catalogs,
                    page: 0,
                    totalCount: result.deliverable_catalogs.length,
                  });
                })
                .catch((err) => {
                  resolve({ data: [], page: 0, totalCount: 0 });
                });
            })
          }
          actions={actionButtons}
        />
        <Fileupload 
        openDialog={this.state.openUploadFileModal} 
        closeDialog={this.closeCsvModal}
        updateAfterCsv={this.updateAfterCsv}
        type={1}
        />
        <AskAlert
          openAlert={this.state.openDeleteAlert}
          handleCloseCancel={this.cancelDelete}
          handleCloseOk={this.deleteCatalog}
          dialogTitle="Delete Catalog"
          dialogContent="Are you sure to delete this catalog?"
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    dc: state.dc,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { withRef: true }
)(ListCatalog);



// WEBPACK FOOTER //
// ./src/features/dc/ListCatalog.js